<template>
    <div class="section">
        <div class="anchor" id="product"></div>
        <img class="title" src="@/assets/images/title_02.png" alt="">

        <div class="sec-product" id="product">
            <div class="wave wave2"><img src="@/assets/images/wave_02.jpg" alt=""></div>
            <div class="wave wave3"><img src="@/assets/images/wave_03.jpg" alt=""></div>
            <div class="wave wave4"><img src="@/assets/images/wave_04.jpg" alt=""></div>
            <div class="box-swiper">
                <swiper :options="{ ...swiperOption, slidesOffsetBefore: isSP ? 60 : 280 }" ref="mySwiper">
                    <swiper-slide><router-link to="/product/piano" class="product product1"><div class="btn-plus"><i class="remixicon-add-line"></i></div><img src="@/assets/images/product_01.jpg" alt=""></router-link></swiper-slide>
                    <swiper-slide><router-link to="/product/ekb" class="product product2"><div class="btn-plus"><i class="remixicon-add-line"></i></div><img src="@/assets/images/product_02.jpg" alt=""></router-link></swiper-slide>
                    <swiper-slide><router-link to="/product/guitar" class="product product4"><div class="btn-plus"><i class="remixicon-add-line"></i></div><img src="@/assets/images/product_04.jpg" alt=""></router-link></swiper-slide>
                    <swiper-slide><router-link to="/product/wind" class="product product3"><div class="btn-plus"><i class="remixicon-add-line"></i></div><img src="@/assets/images/product_03.jpg" alt=""></router-link></swiper-slide>
                    <swiper-slide><router-link to="/product/av" class="product product5"><div class="btn-plus"><i class="remixicon-add-line"></i></div><img src="@/assets/images/product_05.jpg" alt=""></router-link></swiper-slide>
                </swiper>

                <div class="swiper-button-prev"><i class="remixicon-arrow-left-line"></i></div>
                <div class="swiper-button-next"><i class="remixicon-arrow-right-line"></i></div>
                <p v-if="isSP" class="hint">左右滑动切换展品类型</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SecProduct',
    data() {
        return {
            swiperOption: {
                // slidesOffsetBefore: window.innerWidth < 1024 ? 200 : 0,
                slidesPerView: 'auto',
                spaceBetween: 20,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            isSP: false,
            slidesOffsetBefore: 0
            // slidesPerView: window.innerWidth/280,
        }
    },
    created() {
        this.isSP = window.innerWidth < 1024
        // this.slidesOffsetBefore = 
        // window.onresize = () => {
        //     this.slidesPerView = window.innerWidth/700
        //     console.log(this.slidesPerView)
        // }
    }
}
</script>

<style lang="scss" scoped>
.wave {
    position: absolute;
    
    img {
        width: 100%;
    }
}

.wave2 {
    bottom: -6%;
    left: 12%;
}

.wave3 {
    bottom: 14%;
    left: 40%;
}

.wave4 {
    top: 6%;
    left: 55%;
}

.swiper-slide {
    width: auto;
}

.product {
    max-width: 280px;
    position: relative;
    cursor: pointer;

    .btn-plus {
        position: absolute;
        top: 0;
        left: 0;
    }
}

.product1, .product4, .product7 {
    margin-top: 100px;
}

.product3, .product6 {
    margin-top: 67px;
}

.sec-product {
    position: relative;

    .title {
        position: absolute;
        top: 200px;
        left: 90px;
        z-index: 2;
    }
}

.swiper-button-prev, .swiper-button-next {
    background-image: none;
    // background-color: pink;
    width: auto;
    height: auto;
    top: auto;
    bottom: 0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
        color: #fff;
        font-size: 22px;
    }
}

.swiper-button-prev {
    left: 50%;
    margin-left: -60px;
}

.swiper-button-next {
    right: 50%;
    margin-right: -60px;
}


@media all and (max-width: 1024px) {
.hint {
    height: 40px;
    line-height: 40px;
    color: #888;
    // font-size: 3.3vw;
    font-size: 2.5vw;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    z-index: 1;
}

.sec-product {
    padding-bottom: 12%;
    
    .title {
        width: 50%;
        position: static;
    }
}

.product {
    width: 44vw;
    // height: 44vw;

    img {
        width: 100%;
        // height: 100%;
    }
}

.product1, .product4, .product7 {
    margin-top: 40%;
}

.product3, .product6 {
    margin-top: 20%;
}

.swiper-button-prev {
    left: 22%;
    margin-left: 0;
}

.swiper-button-next {
    right: 22%;
    margin-right: 0;
}

.box-swiper {
    // margin-top: 5%;
}

}


@media all and (max-width: 768px) {


.wave {
    width: 30vw;
}

.wave2 {
    bottom: 10%;
    left: 0;
}

.wave3 {
    left: auto;
    right: 0;
    bottom: 20%;
}


}
</style>